<template>
  <div class>
    <sweet-modal ref="modal-upgrade-bundle" class="modal-upgrade-bundle" width="473">
        <div class="cta">
            <img src="/static/images/upgrade-bundle.svg">
            <h3>{{ $t('ct-upgrade-to-go-live') }} </h3>
            <p>{{ $t('ct-upgrade-to-go-live-subtext') }} </p>
            <a class="btn btn-primary w-100" target="_blank" :href="`${officeUrl}/us/office/upgrade`">{{ $t('ct-see-plans') }}</a>
        </div>
    </sweet-modal>
  </div>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';

export default {
  name: 'ModalUpgradeBundle',
  components: {
    SweetModal
  },
  data() {
    return {
    };
  },
  computed: {
    officeUrl() {
      return process.env.OFFICE_URL !== 'undefined'
            ? process.env.OFFICE_URL
            : "https://office.builderall.com";
    }
  },
  methods: {
    open(){
        this.$refs['modal-upgrade-bundle'].open()
    }
  }
};
</script>

<style lang="scss">
.modal-upgrade-bundle .sweet-modal {
    overflow-y: unset;
    .sweet-content {
        padding: 0 !important;
    }
}
</style>

<style lang="scss" scoped>
.modal-upgrade-bundle {
    z-index: 9999999;
    .sweet-modal {
        overflow-y: unset;
    }
    .cta {
        text-align: center;
        img {
            margin-top: -115px;
            margin-bottom: 20px;
        }
        h3 {
            color: #0072E1;
            font-size: 22px;
            font-weight: 600;
            line-height: 110%; /* 24.2px */
            margin: 0;
            font-family: 'Montserrat Semi Bold';
        }
        p {
            color:  #4D5D71;
            text-align: center;
            font-size: 16px;
            font-weight: 500;
            line-height: 150%; /* 24px */
            margin: 0.5rem 0 1rem 0;
            font-family: 'Montserrat Semi Bold';
        }
        a {
            margin: 0;
            text-transform: uppercase;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/ModalUpgradeBundle.vue